import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './StoreAddress.module.scss'

export function Coordinates({
	coordinates,
	close,
}: {
	readonly coordinates: { distance: number }
	readonly close?: boolean
}): React.ReactNode {
	if (coordinates.distance < 0) {
		return null
	}

	return (
		<p
			className={cx(
				text.bodyM,
				styles.distance,
				close && styles.map,
				styles.noMargin
			)}
		>
			{coordinates.distance} km
		</p>
	)
}
